import posthog from "posthog-js";

window.posthog = posthog;
